import { memo } from 'react';

import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import AccessTypeSelector from './access-type-selector';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { ICONS } from '@ui/icons/types';
import IconWithBackdrop from '@ui/icons/icon-with-backdrop';

const AccessTypeRegistrationSettings = memo(() => {
  return (
    <div className="flex-column jc-center gap-8">
      <div className="flex ai-center gap-8">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          Registration page
        </Text>
        <TooltipPortal tooltipContent={<Text design="GlobalIcoText1">Registration Link</Text>}>
          <IconWithBackdrop
            name={ICONS.INFO_CIRCLE}
            size={12}
            color="var(--primitives-mode-1-gray-500)"
            backdropColor="var(--primitives-mode-1-gray-100)"
          />
        </TooltipPortal>
      </div>
      <Container design="GlobalCont1" className="flex ai-center gap-16 jc-space-between radius-12 padding-16">
        <Text tag="h6" className="H6" design="GlobalIcoText1">
          Authentication Flow
        </Text>

        <div>
          <AccessTypeSelector />
        </div>
      </Container>
    </div>
  );
});

AccessTypeRegistrationSettings.displayName = 'AccessTypeRegistrationSettings';

export default AccessTypeRegistrationSettings;
